import React from "react";
import { Link } from "react-router-dom";
import { Checked, ArrowRight } from "../Icons";
import FloatingActionButton from "../FloatingActionButton";
import LeadingText from "../LeadingText";
import SupportingText from "../SupportingText";

export default function CheckoutSuccess() {
  return (
    <div className="w-full h-full flex flex-col justify-between items-center">
      <div
        style={{
          height: "25%"
        }}
        className="w-full flex flex-col items-center justify-around"
      >
        <SupportingText textAlign="center" fontWeight="thin" textSize="xl">
          Vielen Dank für Ihre Bestellung.
        </SupportingText>
      </div>
      <div
        style={{
          height: "50%"
        }}
        className="w-full flex flex-col justify-around items-center bg-white shadow-blur-lg rounded-sm"
      >
        <div
          style={{
            width: "150px",
            height: "150px"
          }}
          className="rounded-full border-2 border-green-light flex items-center justify-center"
        >
          <Checked height="100" width="100" stroke="#51D88A" />
        </div>
        <LeadingText
          textColor="green-light"
          textAlign="center"
          textSize="2xl"
          fontWeight="thin"
        >
          Bestellung erfolgreich
        </LeadingText>
      </div>
      <div
        style={{
          height: "25%"
        }}
        className="w-full flex items-center justify-around"
      >
        <SupportingText textColor="black" textSize="xl" fontWeight="thin">
          Zurück zu den Artikeln
        </SupportingText>
        <Link to="/article">
          <FloatingActionButton bgColor="red-lightest" size="xs">
            <ArrowRight stroke="#EF5753" height="15px" />
          </FloatingActionButton>
        </Link>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/Checkout/CheckoutSuccess.js